import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export async function notify(type: string | number, message: string | number, autoClose = 5000, extra: any = {}) {
	if (type === "new message") {
		toast(message, {
			position: "bottom-left",
			autoClose: autoClose,
			icon: "📨",
			closeOnClick: true
		});
	}
	if (type === "loading") {
	}
	if (type === "promise") {
		await toast.promise(
			extra.fetch,
			{
				pending: extra.pending,
				success: extra.success,
				error: extra.error
			},
			{
				position: "top-center",
				autoClose: autoClose,
				closeOnClick: true
			}
		);
	}
	if (type === "success") {
		toast.success(message, {
			position: "bottom-left",
			autoClose: autoClose,
			closeOnClick: true
		});
	}
	if (type === "error") {
		toast.error(message, {
			position: "bottom-left",
			autoClose: autoClose,
			closeOnClick: true
		});
	}
	if (type === 500) {
		toast.error(message, {
			position: "bottom-left",
			autoClose: autoClose,
			closeOnClick: true
		});
	}
}
